import { t } from 'i18next';

const months = [
  t('components:monthPicker.months.january'),
  t('components:monthPicker.months.february'),
  t('components:monthPicker.months.march'),
  t('components:monthPicker.months.april'),
  t('components:monthPicker.months.may'),
  t('components:monthPicker.months.june'),
  t('components:monthPicker.months.july'),
  t('components:monthPicker.months.august'),
  t('components:monthPicker.months.september'),
  t('components:monthPicker.months.october'),
  t('components:monthPicker.months.november'),
  t('components:monthPicker.months.december'),
];

export default months;
